// src/pages/Commissions/ActeurCommissionModal.jsx
// ou src/components/Modal/Modal.jsx selon ton organisation
import React from "react";
import PropTypes from "prop-types";
import { FaTimes } from "react-icons/fa";
import Button from "../../components/Button/Button";

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="w-full max-w-2xl mx-4 bg-white dark:bg-slate-900 dark:text-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="px-5 py-3 flex items-center justify-between bg-gradient-to-r from-primary via-indigo-500 to-cyan-500">
          <h3 className="text-sm sm:text-base md:text-lg font-bold uppercase tracking-[0.18em] text-white">
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-black/30 hover:bg-black/60 text-white"
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenu */}
        <div className="p-5 max-h-[70vh] overflow-y-auto text-sm">
          {children}
        </div>

        {/* Footer optionnel : si tu préfères utiliser Button */}
        <div className="px-5 pb-4 flex justify-end">
          <Button
            text="Fermer"
            icon={FaTimes}
            onClick={onClose}
            className="gap-2 btn-ghost text-sm"
          />
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Modal;
